import { AdminLayout } from "~/components/common/layouts/AdminLayout";
import Styles from "./Page.module.scss";

type Props = {
	message?: string;
};

export function Page({ message }: Props) {
	return (
		<AdminLayout>
			<div className={Styles.ErrorContainer}>
				<h1 className={Styles.ErrorTitle}>権限がありません</h1>
				<p className={Styles.ErrorMessage}>{message || ""}</p>
			</div>
		</AdminLayout>
	);
}
